<template>
	<el-select v-model="current" filterable :placeholder="'请选择'+title" style="width:100%;" @change="change">
		<el-option
			v-for="item in list"
			:key="item.value"
			:label="item.label"
			:value="item.value">
		</el-option>
	</el-select>
</template>

<script>
	import axios from 'axios';
	import { ElMessage,ElMessageBox,ElNotification} from 'element-plus';
	export default{
		props:{
			request:{
				type:Object,
				default:{
					url:'',
					params:{},
					method:"get"
				}
			},
			labelkey:{//适配转化为label的对应字段
				type:String,
				default:''
			},
			valuekey:{//适配转化为value的对应字段
				type:String,
				default:''
			},
			combinationLabel:{
				type:Array,
				default:[]
			},
			combinationValue:{
				type:Array,
				default:[]
			},
			title:{
				type:String,
				default:''
			}
		},
		data(){
			return{
				list:'',//选项列表
				current:''
			}
		},
		created(){
		    this.getData();
		},
		methods:{
			/*请求选项*/
			getData(){
				var that=this;
				if(this.request.url){
					axios({
						method:this.request.method||'get',
						url:this.request.url,
						params:this.request.params||{}
					}).then((response) => {
						that.list=response.data.data.map((item)=>{
							let value='',label='';
							if(that.valuekey){
								value=item[that.valuekey]+''
							}
							if(that.labelkey){
								label=item[that.labelkey]
							}
							if(that.combinationLabel.length){
								that.combinationLabel.forEach((v,i)=>{
									label=label+' '+item[v]
								})
							}
							return{
								value:value,
								label:label
							}
						});
					}).catch((error) => {
						ElNotification.error({
							title: '请求错误',
							message:'服务器发生错误！'
						});
					})
				}
			},
			/*选择事件*/
			change(e){
				this.current=e;
				this.$emit('input',e);
				this.$emit('change',e);
			}
		}
	}
</script>

<style>
</style>
